import { RE_INITIALIZE_CART_CATEGORY, SET_CART_CATEGORY_CATEGORIES, SET_CART_CATEGORY_CATEGORY_ID, SET_CART_CATEGORY_PRODUCT_TYPE } from '../../actionTypes/cartCategory'

export const reInitializeCartCategory = () => ({ type: RE_INITIALIZE_CART_CATEGORY })

export const setCartCategoryCategories = value => ({ type: SET_CART_CATEGORY_CATEGORIES, value })

export const setCartCategoryProductType = value => ({ type: SET_CART_CATEGORY_PRODUCT_TYPE, value })

export const setCartCategoryCategoryId = value => ({ type: SET_CART_CATEGORY_CATEGORY_ID, value })
